import { UserToken } from "../types/token/token";
// import AuthService from "./auth/authService";
// import ExampleService from "./example/exampleService";
// import QueryService from "./query/queryService";
import SearchService from "./search/searchService";
import GroupService from "./group/groupService";
import CollectionListRulesService from './rules/collectionListRulesService'
import AdminService from "./admin/adminService";
import CollaborationService from "./collaboration/collaborationService";
import UserService from "./user/userService";
// import UserSettingsService from "./userSettings/userSettingsService";

// export const authService = new AuthService(null)
// export const exampleService = new ExampleService(null)
export const searchService = new SearchService(null)
// export const queryService = new QueryService(null)
export const groupService = new GroupService(null)
// export const userSettingsService = new UserSettingsService(null)
export const collectionListRulesService  = new CollectionListRulesService(null)
export const adminService = new AdminService(null)
export const collaborationService = new CollaborationService(null)
export const userService = new UserService(null)

export const registerServices = (userToken: UserToken, url?: string) => {
    // authService.setToken(userToken)
    // exampleService.setToken(userToken)
    searchService.setToken(userToken, url)
    // queryService.setToken(userToken)
    groupService.setToken(userToken, url)
    collectionListRulesService.setToken(userToken, url)
    adminService.setToken(userToken, url)
    collaborationService.setToken(userToken, url)
    userService.setToken(userToken, url)
    // userSettingsService.setToken(userToken)
}